import React from 'react'
import { NavigationItem } from '../sidebarHelper'
import NavigationLink from './NavigationLink'

interface Props {
    items: NavigationItem[]
    showTooltip: boolean
    shouldSkipHistoryApi: boolean
    currentRoute: string
    currentOrganization: string | undefined
}
export class NavigationListView extends React.PureComponent<Props> {
    public render = () => (
        <ul className="sideNav-list">
            {this.props.items.map((item, index) => (
                <li className="sideNav-listItem" key={index}>
                    <NavigationLink
                        icon={item.icon}
                        label={item.label}
                        isActive={
                            this.props.currentRoute === item.route ||
                            (item.alternativeRoutes && this.props.currentRoute in item.alternativeRoutes) ||
                            false
                        }
                        route={item.route}
                        parameters={item.parametersCallback ? item.parametersCallback(this.props.currentOrganization) : item.parameters}
                        supportsAllServices={item.supportsAllServices}
                        setSkipHistoryApi={this.props.shouldSkipHistoryApi || item.alwaysSkipHistoryApi || false}
                        showTooltip={this.props.showTooltip}
                    />
                </li>
            ))}
        </ul>
    )
}
